import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {map,catchError} from 'rxjs/operators'
import { v4 as SessionID } from 'uuid';
@Injectable({
  providedIn: 'root'
})
export class CustomerinformationService {
  public _CustomerInformationService = environment.CustomerinformationService;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"]
    this._httpOptions = {
      headers: new HttpHeaders({ 'SessionId':this.sessionId })
    };
  
  }
  GetPageInitializeDetails(): Observable<any>{
   
    var Query = this._CustomerInformationService ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  InsertCustomer(customersite: object) {
  
    // console.log("Create");
    var Query = this._CustomerInformationService;
    return this.http.post<{ data: any }>(Query, customersite,this._httpOptions);
  }
  UpdateCustomerSite(customersite: object) {
   
    // console.log("Update");
    var Query = this._CustomerInformationService;
    // console.log(Query);
    return this.http.put<{ data: any }>(Query, customersite,this._httpOptions);
  }
  UploadFile(C_Customer:FormData,Folder:string){

    // console.log("Create");
    var Query = this._CustomerInformationService + "?file=" + C_Customer + "&folder=" + Folder ;
    return this.http.post<{ data: any }>(Query, C_Customer,this._httpOptions);
  }
  GetById(customercode:string): Observable<any>{
   
    var Query = this._CustomerInformationService + '/GetById' +'/'+ customercode;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  GetByCustomersiteId(customersiteId:string): Observable<any>{
   
    var Query = this._CustomerInformationService + '/GetByCustomersiteId' +'/'+ customersiteId;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  GetAll()
  {
  
    var Query = this._CustomerInformationService + '/GetAll' ;
    // console.log(Query);
    return this.http.get<{data:any}>(Query,this._httpOptions).pipe(map(data=>{
      const resultJSON = JSON.parse(JSON.stringify(data));
      // console.log(resultJSON); 
     return data; 
    }),);
  }

  GetAllPreQuote()
  {
    var Query = this._CustomerInformationService + '/GetAllPreQuote' ;
    // console.log(Query);
    return this.http.get<{data:any}>(Query,this._httpOptions).pipe(map(data=>{
      const resultJSON = JSON.parse(JSON.stringify(data));
      // console.log(resultJSON); 
     return data; 
    }),);
  }

  UpdateCustomerNameUsingGStVerify(customerCode:string,gstCustomerName:string,gstNumber:string) {
   
    var Query = this._CustomerInformationService + '/UpdateCustomerNameUsingGStVerify' +'/'+ customerCode +'/'+ gstCustomerName +'/'+ gstNumber;
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }

}
